const CustomCursor = {
    v:{
        cur: null,
        flw: null,
        dot: null,
        mouse: {
            x:Math.round(window.innerWidth * 0.5),
            y:Math.round(window.innerHeight * 0.5),
            fx:Math.round(window.innerWidth * 0.5),
            fy:Math.round(window.innerHeight * 0.5),
            fast: 0.2,
            slow: 0.8,
            spd: 0.8
        },
        xTo: null,
        fxTo: null,
        yTo: null,
        fyTo: null,
        active: window.innerWidth > 991,
        icons: new Set(),
        first: true
    },
    init: function(){
        let $this = this;
        let v = this.v;
        let cur = $("#cursor");
        if(cur.length <= 0){
            console.error("No #cursor element found!");
            return false;
        }
        let $body = $("body");
        if(v.active){
            $body.addClass("custom-cursor");
        }
        v.cur = cur;
        let flw = cur.find(".cursor-follower");
        let dot = cur.find(".cursor-point");
        v.flw = flw;
        v.dot = dot;

        let fxTo = gsap.quickTo(v.flw, "x", {duration: v.mouse.spd, ease: "power3"});
        let fyTo = gsap.quickTo(v.flw, "y", {duration: v.mouse.spd, ease: "power3"});
        let xTo = gsap.quickSetter(dot, "x", "px");
        let yTo = gsap.quickSetter(dot, "y", "px");

        v.xTo = xTo;
        v.fxTo = fxTo;
        v.yTo = yTo;
        v.fyTo = fyTo;

        $(window).on("pointermove", e => {
            if(!v.active) return false;
            if(v.first){
                $("body").addClass("moved");
                v.first = false;
                fxTo(e.clientX, e.clientX);
                fyTo(e.clientY, e.clientY);
            }else{
                fxTo(e.clientX);
                fyTo(e.clientY);
            }
            
            xTo(e.clientX);
            yTo(e.clientY);
        });

        $("iframe").each(function (idx, iframe) {
            let $f = $(iframe);
            $f.on("mouseover mouseenter", function(e){
                $body.removeClass("custom-cursor");
                v.active = false;
            });
            $f.on("mouseoout mouseleave", function(e){
                let act = window.innerWidth > 991;
                if(act != v.active){
                    if(act){
                        v.first = true;
                        $body.addClass("custom-cursor");
                    }else{
                        $body.removeClass("custom-cursor");
                    }
                }
                v.active = act;
            });
        });

        let ctmo = 0;
        window.addEventListener("resize", function(){
            clearTimeout(ctmo);
            ctmo = setTimeout(function(){
                let act = window.innerWidth > 991;
                if(act != v.active){
                    if(act){
                        $body.addClass("custom-cursor");
                    }else{
                        $body.removeClass("custom-cursor");
                    }
                }
                v.active = act;
            }, 100);
        });

        function iconChange(){
            if(v.icons.has("close")){
                $this.fast();
                v.cur.attr("class", "close");
                return false;
            }
            if(v.icons.has("eye_important")){
                $this.fast();
                v.cur.attr("class", "eye");
                return false;
            }
            if(v.icons.has("drag")){
                $this.fast();
                v.cur.attr("class", "drag");
                return false;
            }
            if(v.icons.has("left")){
                $this.fast();
                v.cur.attr("class", "left");
                return false;
            }
            if(v.icons.has("right")){
                $this.fast();
                v.cur.attr("class", "right");
                return false;
            }
            if(v.icons.has("down")){
                $this.fast();
                v.cur.attr("class", "down");
                return false;
            }
            if(v.icons.has("up")){
                $this.fast();
                v.cur.attr("class", "up");
                return false;
            }
            if(v.icons.has("text")){
                $this.fast();
                v.cur.attr("class", "text");
                return false;
            }
            if(v.icons.has("eye")){
                $this.fast();
                v.cur.attr("class", "eye");
                return false;
            }
            if(v.icons.has("link-basic")){
                $this.fast();
                v.cur.attr("class", "link");
                return false;
            }
            $this.slow();
            v.cur.attr("class", "");
        }

        $('body').on("mouseover mouseenter mouseup", "a, input, .tns-item, button, .fancybox-slide, .btn, .apartment-page .favorites, .slider-btn, input+.box, .favorites-js", function(e){
            if(!v.active) return false;
            v.icons.clear();
            let el = $(this);
            let cls = el.attr("class");
            if(typeof(cls) == 'undefined') cls = '';

            v.icons.add("link-basic");

            iconChange();
        });
        $('body').on("mouseoout mouseleave", "a, input, .tns-item, button, .fancybox-slide, .btn, .apartment-page .favorites, .slider-btn, input+.box, .favorites-js", function(){
            if(!v.active) return false;
            let el = $(this);
            let cls = el.attr("class");
            if(typeof(cls) == 'undefined') cls = '';
            
            v.icons.delete("link-basic");

            iconChange();
        });

    },

    clear: function(){
        let v = this.v;
        v.icons.clear();
        this.slow();
        v.cur.attr("class", "");
    },
    fast: function(){
        let v = this.v;
        v.mouse.spd = v.mouse.fast;
        v.fxTo.tween.duration(v.mouse.spd);
        v.fyTo.tween.duration(v.mouse.spd);

    },
    slow: function(){
        let v = this.v;
        v.mouse.spd = v.mouse.slow;
        v.fxTo.tween.duration(v.mouse.spd);
        v.fyTo.tween.duration(v.mouse.spd);
    }
};